import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from '@material-ui/core';
import LoadingIcon from '../../Components/Common/LoadingIcon';
import { withdraw, clearSuccess } from '../../store/actions/user.actions';
import { Translate } from '../../localization';
import { toastr } from 'react-redux-toastr';
import { currencyType } from '../../config';
class WithdrawModel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inputAmount: 0,
            inputAddress: null,
            inputCurrency: null,
            amountError: null,
            addressError: null,
            currencyError: null,
            loading: false,
        };
    }
    validate(prevState) {
        if (prevState) {
            if (prevState.inputAmount !== this.state.inputAmount) {
                if (!this.state.inputAmount) {
                    this.setState({ amountError: Translate.required });
                } else {
                    this.setState({ amountError: false });
                }
            }

            if (prevState.inputAddress !== this.state.inputAddress) {
                if (!this.state.inputAddress) {
                    this.setState({ addressError: Translate.required });
                } else {
                    this.setState({ addressError: false });
                }
            }

            if (prevState.inputCurrency !== this.state.inputCurrency) {
                if (!this.state.inputCurrency) {
                    this.setState({ currencyError: Translate.required });
                } else {
                    this.setState({ currencyError: false });
                }
            }
        } else {
            if (this.state.inputAmount < 23) {
                this.setState({ amountError: Translate.greaterThanZero });
            }
            if (!this.state.inputAddress) {
                this.setState({ addressError: Translate.required });
            }
            if (!this.state.inputCurrency) {
                this.setState({ currencyError: Translate.required });
            }
        }
    }
    componentDidUpdate(prevProps, prevState) {
        const { withdrawError, withdrawSuccess } = this.props;
        if (prevProps.withdrawError !== withdrawError) {
            this.setState({ ...this.state, loading: false });
            if (withdrawError) toastr.error('', withdrawError);
        }

        if (prevProps.withdrawSuccess !== withdrawSuccess) {
            this.setState({ ...this.state, loading: false });
            if (withdrawSuccess) toastr.success('', withdrawSuccess);
        }
        this.validate(prevState);
    }

    componentWillUnmount() {
        this.props.clearSuccess();
    }

    handleSubmit = (e) => {
        const { inputAmount, inputAddress, inputCurrency, addressError, amountError, currencyError } = this.state;
        if (!addressError
            && !amountError
            && !currencyError
            && inputAmount > 0
            && inputAddress && inputAddress.length > 0
            && inputCurrency && inputCurrency.length > 0
        ) {
            this.setState({ loading: true });
            this.props.withdraw({
                amount: inputAmount,
                address: inputAddress,
                currency: inputCurrency,
            });
        } else {
            this.validate();
        }
    };

    handleChange = (e) => {
        this.setState({
            ...this.state,
            [e.target.id]: e.target.value,
            loading: false
        });
    }

    hideForm = () => {
        this.setState({ isOpen: false });
    }

    render() {
        const currencyList2 = currencyType.map((option) => (
            <option key={option.value} value={option.value} selected={this.state.inputCurrency === option.value}>
                {option.name}
            </option>
        ));
        const {
            amountError,
            addressError,
            currencyError,
            loading } = this.state
        return (
            <div className="changes-pass">
                <div className='div-1'>
                    <span className={`mt-1 ${amountError ? 'auth__error-field' : ''}`}>
                        {<p className="auth__error sm">{'Please enter USD amount'}</p>}
                        <input
                            type="number"
                            className="auth__input"
                            id='inputAmount'
                            placeholder={Translate.enterAmount}
                            onChange={this.handleChange}
                        />
                        {amountError && <p className="auth__error sm">{amountError}</p>}
                    </span>
                    <span className={`mt-2 ${addressError ? 'auth__error-field' : ''}`}>
                        <input
                            type="text"
                            className="auth__input"
                            id='inputAddress'
                            placeholder={Translate.coinAddress}
                            onChange={this.handleChange}
                        />
                        {
                            addressError && <p className="auth__error sm">{addressError}</p>
                        }
                    </span>
                    <span className={'mt-1'}>
                        <select className='auth__input' id='inputCurrency' onChange={this.handleChange}>
                            <option disabled selected className='disabled'>{Translate.currency2}</option>
                            {currencyList2}
                        </select>
                        {
                            currencyError && <p className="auth__error sm">{currencyError}</p>
                        }
                        <Button
                            variant="contained"
                            className="auth__btn d-flex justify-content-center align-items-center dep-btn"
                            type="submit"
                            onClick={() => this.handleSubmit()}
                            disabled={loading}
                        >
                            {loading ? <LoadingIcon /> : Translate.withdraw}
                        </Button>
                    </span>
                </div>
            </div>
        );
    }
}

WithdrawModel.propTypes = {
    hideDepositForm: PropTypes.func,
};

const mapStateToProps = (state) => {
    return {
        withdrawSuccess: state.user.withdrawSuccess,
        withdrawError: state.user.withdrawError,
        userData: state.user.data,
        openotpForm: state.user.openOtpForm,
        getOtpError: state.user.getOtpError,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        clearSuccess: () => dispatch(clearSuccess()),
        withdraw: (obj) => dispatch(withdraw(obj))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithdrawModel);
